import styled from 'styled-components'

export const LicenseRowActionsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`
